import { Box, Tooltip } from '@lego/klik-ui';
import { CloudUnavailableBold, StatusSuccessBold } from '@lego/klik-ui/icons';
import { dateTimeFormat } from '@/utility/date';

type Props = {
  isConnected: boolean;
  isConnectedUpdatedAt: string;
};

export const ConnectedStatusIcon = (props: Props) => {
  return (
    <>
      {props.isConnected ? (
        <Tooltip
          label={`The device is currently online and connected at ${new Date(
            props.isConnectedUpdatedAt
          ).toLocaleString(dateTimeFormat.local)}`}
        >
          <Box textAlign="center">
            <StatusSuccessBold color="green" />
          </Box>
        </Tooltip>
      ) : (
        <Tooltip
          label={`The device is currently offline and disconnected at ${new Date(
            props.isConnectedUpdatedAt
          ).toLocaleString(dateTimeFormat.local)}`}
        >
          <Box textAlign="center">
            <CloudUnavailableBold color="grey" />
          </Box>
        </Tooltip>
      )}
    </>
  );
};
